import Decimal from "decimal.js-light";
export const convertStopUnitsStringToDecimal = (su) => ({
    ...su,
    quantity: su.quantity ? new Decimal(su.quantity) : null,
    weight: su.weight ? new Decimal(su.weight) : null,
    height: su.height ? new Decimal(su.height) : null,
    width: su.width ? new Decimal(su.width) : null,
    length: su.length ? new Decimal(su.length) : null,
    volume: su.volume ? new Decimal(su.volume) : null,
    colli: su.colli ? new Decimal(su.colli) : null,
});
export const convertStopUnitsDecimalToString = (su) => ({
    ...su,
    quantity: su.quantity?.toString() || null,
    weight: su.weight?.toString() || null,
    height: su.height?.toString() || null,
    width: su.width?.toString() || null,
    length: su.length?.toString() || null,
    volume: su.volume?.toString() || null,
    colli: su.colli?.toString() || null,
});
//# sourceMappingURL=stop-units.js.map